import { errorCodeOf, errorDetailsOf } from "@luckymenu/api-client";

/**
 * Why a menu change was refused, for a message both apps translate from
 * `menu:problems.<problem>`. See api.md, Catalog (staff), for the reasons.
 */
export type MenuProblem =
	| "network"
	| "forbidden"
	| "notFound"
	| "taken"
	| "categoryNotEmpty"
	| "defaultTaxClass"
	| "lastKitchenStation"
	| "photo"
	| "price"
	| "invalid"
	| "failed";

export function menuProblemOf(error: unknown): MenuProblem {
	const code = errorCodeOf(error);
	const details = errorDetailsOf(error);
	if (code === "NETWORK") return "network";
	if (code === "FORBIDDEN") return "forbidden";
	if (code === "NOT_FOUND") return "notFound";
	if (code === "CONFLICT") {
		switch (details.reason) {
			case "taken":
				return "taken";
			case "category_not_empty":
				return "categoryNotEmpty";
			case "default_tax_class":
				return "defaultTaxClass";
			case "last_kitchen_station":
				return "lastKitchenStation";
		}
	}
	if (code === "VALIDATION") {
		if (details.field === "fileId") return "photo";
		if (details.field === "basePricePaise") return "price";
		return "invalid";
	}
	return "failed";
}

/** The count a `category_not_empty` refusal carries, for "Move or delete its 4 items first". */
export function problemCount(error: unknown): number | null {
	const count = errorDetailsOf(error).count;
	return typeof count === "number" ? count : null;
}
